/**
 * Ob die **Listen-Werkzeug-Pille** abgetaucht ist: solange angelegt wird —
 * egal, ob über die Pille oder per Kürzel (#229). Sonst stünde sie beim
 * Anlegen per Taste über dem Ersteller unten in der Liste, beim Klick nicht.
 */
export function isListToolbarRetracted({ creatingTask, namingSection, placingPaper, draggingFromPill }: {
  /** Ein Ersteller ist offen — auch bei Enter-und-weiter. */
  creatingTask: boolean
  /** Ein frischer Abschnitt ist angelegt und hat noch keinen Namen. */
  namingSection: boolean
  /** Eine Notiz oder ein Memo AUS DER PILLE hängt am Zeiger — eines aus der Pinnwand zählt nicht. */
  placingPaper: boolean
  /**
   * „Neue Aufgabe“ (#301) oder „Abschnitt“ (#314) wird aus der Pille gezogen — wie Notiz und Memo schon beim
   * Ziehen, nicht erst, wenn nach dem Fallenlassen angelegt wird (Sven, 11.10.2026).
   */
  draggingFromPill: boolean
}): boolean {
  return creatingTask || namingSection || placingPaper || draggingFromPill
}
